export enum PostLoginActionType {
  CHECK_EMAIL = 'CHECK_EMAIL',
  CHECK_BILLING_ADDRESS = 'CHECK_BILLING_ADDRESS',
  TAC_RECONFIRMATION = 'TAC_RECONFIRMATION',
}

export interface PostLoginAction {
  type: PostLoginActionType;
  timestamp: number;
  data?: {
    email?: string;
    billingAddress?: any;
  };
}

const STORAGE_KEY = 'postLoginActions';

/**
 * Utility for managing post-login actions in localStorage.
 * Actions are stored as a queue and processed sequentially.
 */
export const postLoginActionsStorage = {
  /**
   * Get all pending actions from localStorage
   */
  getActions: (): PostLoginAction[] => {
    if (typeof localStorage === 'undefined') return [];
    const item = localStorage.getItem(STORAGE_KEY);
    if (!item) return [];
    try {
      return JSON.parse(item);
    } catch {
      return [];
    }
  },

  /**
   * Add action(s) to the queue
   */
  setActions: (actions: PostLoginAction[]): void => {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(actions));
    // Dispatch custom event for reactive components
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('postLoginActionsChanged'));
    }
  },

  /**
   * Remove first action from queue
   */
  removeFirstAction: (): void => {
    if (typeof localStorage === 'undefined') return;
    const actions = postLoginActionsStorage.getActions();
    const updated = actions.slice(1);
    if (updated.length > 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('postLoginActionsChanged'));
    }
  },

  /**
   * Clear all actions from localStorage
   */
  clearActions: (): void => {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(STORAGE_KEY);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('postLoginActionsChanged'));
    }
  },
};
